import React from 'react';
import { Helmet } from 'react-helmet';

import { websiteSchema, organizationSchema } from '../../structured-data';
import JsonLD from '@components/JsonLD/JsonLD';
import Favicon from './Favicon';

const SEO = props => {
  return (
    <>
      <Favicon />
      <Helmet>
        <title>{props.title || 'Sharetribe - Create an online marketplace'}</title>
        {props.noIndex ? <meta name="robots" content="noindex, nofollow" /> : null}
        <meta
          name="description"
          content={
            props.description ||
            'Create an online marketplace platform - fast. Sharetribe helps you build a successful marketplace business for rentals, services, events, or products.'
          }
        />
        <meta name="publisher" content="Sharetribe" />
        <meta name="author" content="Sharetribe" />
        <meta name="copyright" content="Sharetribe" />
        <meta http-equiv="content-language" content="en" />
        <meta http-equiv="content-type" content="text/html" charset="UTF-8" />
        {/* OpenGraph Tags */}
        <meta property="fb:app_id" content="208630779265610" />
        <meta property="og:url" content={props.linkRel || 'https://www.sharetribe.com'} />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={props.socialTitle || 'Sharetribe - Create a marketplace business'}
        />
        <meta
          property="og:image"
          content={props.socialImage || 'https://www.sharetribe.com/og-image-sharetribe.jpeg'}
        />
        <meta
          property="og:description"
          content={
            props.socialDescription ||
            'Build an online marketplace platform - fast! Get started for free. Code or no code. All essential features for any marketplace type.'
          }
        />
        {/* Technical SEO */}
        <link rel="canonical" href={props.linkRel} />
        <html lang="en" />
        {/* Twitter Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@sharetribe" />
        <meta name="twitter:creator" content="@sharetribe" />
        <meta name="twitter:domain" content="sharetribe.com" />
        <meta name="twitter:url" content={props.linkRel || 'https://www.sharetribe.com'} />
        <meta
          name="twitter:title"
          content={props.socialTitle || 'Sharetribe - Create a marketplace business'}
        />
        <meta
          name="twitter:description"
          content={
            props.socialDescription ||
            'Build an online marketplace platform - fast! Get started for free. Code or no code. All essential features for any marketplace type.'
          }
        />
        <meta
          name="twitter:image"
          content={props.socialImage || 'https://www.sharetribe.com/og-image-sharetribe.jpeg'}
        />
        <meta
          name="twitter:image:alt"
          content={props.socialImagealt || 'https://www.sharetribe.com/og-image-sharetribe.jpeg'}
        />
        <script type="text/javascript" src={props.scriptURL || ''}></script>
      </Helmet>
      <JsonLD>{websiteSchema}</JsonLD>
      <JsonLD>{organizationSchema}</JsonLD>
    </>
  );
};

export default SEO;
